export default __webpack_public_path__ + "static/media/FAST.de61c30e.png";